import GridItem from "../../components/general/GridItem";
import Headline from "../../components/general/Headline";

const HeadlineModule = ({ label, title }: Queries.HeadlineModuleFragment) => (
	<GridItem>
		<Headline label={label} title={title} />
	</GridItem>
);

export default HeadlineModule;
